import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, InputGroup, Pagination } from 'react-bootstrap';
import CustomHead from '../components/CustomHead';
import LezioneCard from '../components/LezioneCard';
import TeseoPlusBanner from '../components/TeseoPlusBanner';
import api from "../API/backend";
import { useUserAuth } from "../components/UserAuthContext";


const Lezioni = () => {
    const { userData } = useUserAuth();
    const [searchQuery, setSearchQuery] = useState(null);
    const [lessonsData, setLessonsData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const limit = 21;
    const userType = userData?.type;

    const fetchLessons = async (search = '', pageNumber = 1) => {
        try {
            const response = await api.get(`${process.env.REACT_APP_BACKEND_PATH}/lessons`, {
                params: {
                    page: pageNumber,
                    limit,
                    search: search,
                }
            });
            if (response.status === 200) {
                setLessonsData(response.data.lessons);
                setTotalPages(Math.ceil(response.data.total / limit));
            }
        } catch (error) {
            console.error('Error fetching lessons:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLessons(searchQuery, page);
    }, [page, userData]);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setPage(1);
        fetchLessons(searchQuery, 1);
    };

    const goToPage = (newPage) => {
        setPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const renderPagination = () => (
        <Pagination
            className="justify-content-center mt-4"
            style={{
                '--bs-pagination-active-bg': 'red',
                '--bs-pagination-active-border-color': 'red',
                '--bs-pagination-hover-bg': '#ffe6e6',
                '--bs-pagination-focus-bg': 'red',
                '--bs-pagination-focus-border-color': 'red',
                '--bs-pagination-hover-color': 'red',
                '--bs-pagination-color': 'black',
            }}
        >
            <Pagination.Prev onClick={() => goToPage(Math.max(page - 1, 1))} disabled={page === 1} />
            {[...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === page} onClick={() => goToPage(i + 1)}>
                    {i + 1}
                </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => goToPage(Math.min(page + 1, totalPages))} disabled={page === totalPages} />
        </Pagination>
    );

    return (
        <main className="App">
            <CustomHead
                title="Teseo.app | Lezioni"
                description="Lezioni di latino e greco."
                keywords="teseo.app, teseo, latino, greco, traduzione, analisi, versione, lezioni"
                author="Teseo"
                canonicalUrl="https://teseo.app/lezioni"
            />

            <Container className='pt-20'>
                <Row className='my-5 justify-content-center d-flex align-items-center'>
                    <Col xs="auto">
                        <span className='bolder fontXXL white'>Lezioni</span>
                    </Col>
                </Row>

                <Row className='justify-content-center'>
                    <Col lg={4} xs={12}>
                        <Form onSubmit={handleSearchSubmit}>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Cerca tra le lezioni..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <Button variant="danger" type="submit">Cerca</Button>
                            </InputGroup>
                        </Form>
                    </Col>
                </Row>
            </Container>

            <Container className='pt-10'>
                <Row>
                    {loading ? (
                        Array.from({ length: limit }).map((_, index) => (
                            <Col xs={12} md={6} lg={4} key={index} className="mb-4">
                                <div className="p-4 rounded bg-black d-flex flex-column justify-content-center align-items-center" style={{ height: '180px' }}>
                                    <div className="spinner-border text-danger mb-3" role="status" />
                                </div>
                            </Col>
                        ))
                    ) : lessonsData.length === 0 ? (
                        <Col className="text-center py-5 text-white">
                            <h4>Nessuna lezione trovata...</h4>
                        </Col>
                    ) : (
                        lessonsData.map((lesson) => (
                            <Col xs={12} md={6} lg={4} key={lesson.codice} className="mb-4">
                                <LezioneCard
                                    title={lesson.title}
                                    subtitle={lesson.description}
                                    duration={`~${(lesson.order_custom + 1) * 5} min`}
                                    lessonId={lesson.codice}
                                    premium={lesson.premium}
                                />
                            </Col>
                        ))
                    )}
                </Row>
                {renderPagination()}
            </Container>

            {userType === "normal" && (
                <Container className='pt-40'>
                    <TeseoPlusBanner />
                </Container>
            )}
        </main>
    );
};

export default Lezioni;